import ka from '../../locales/ka.json';
import en from '../../locales/en.json';
import type { Locale } from './config';

type MessageDictionary = Record<string, string>;

type MessageValue = string | MessageTree;

interface MessageTree {
  [key: string]: MessageValue;
}

function flattenMessages(messages: MessageTree, prefix = ''): MessageDictionary {
  return Object.entries(messages).reduce<MessageDictionary>((acc, [key, value]) => {
    const prefixedKey = prefix ? `${prefix}.${key}` : key;
    if (typeof value === 'string') {
      acc[prefixedKey] = value;
      return acc;
    }

    Object.assign(acc, flattenMessages(value, prefixedKey));
    return acc;
  }, {});
}

export const messagesByLocale: Record<Locale, MessageDictionary> = {
  ka: flattenMessages(ka as MessageTree),
  en: flattenMessages(en as MessageTree),
};
